import { Component, Input, OnInit, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";

@Component({
  selector: "app-report-viewer-modal",
  templateUrl: "./report-viewer-modal.component.html",
  styleUrls: ["./report-viewer-modal.component.scss"],
})
export class ReportViewerModalComponent implements OnInit {
  @Input() destination: any;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private _gestionFichierService: GestionFichierService
  ) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {}
}
